export const common = {
  nav: {
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    team: 'Our Team',
    contact: 'Contact',
  },
  hero: {
    title: 'Lawyer Ghadeer Salem Ashkanani Office',
    subtitle: 'For Law and Legal Consultations',
    description: 'Legal expertise spanning over 8 years in providing comprehensive legal solutions',
    cta: 'Book Consultation',
    learn: 'Learn More',
  },
  stats: {
    experience: 'Years Experience',
    cases: 'Successful Cases',
    clients: 'Satisfied Clients',
    rate: 'Success Rate',
  },
  about: {
    title: 'About Us',
    subtitle: 'Legal Excellence and Professionalism',
    description: 'Lawyer Ghadeer Salem Ashkanani Office for Law and Legal Consultations is one of the leading law firms in Kuwait, established in 2018 to be a trusted legal destination for providing comprehensive legal solutions based on professionalism, accuracy, and commitment to the highest professional standards.',
    founder: 'The office operates under the supervision and leadership of Lawyer Ghadeer Salem Ashkanani, the founder of the office, who is one of the distinguished legal competencies in the field of law, holds a Master\'s degree in Law, and has practical experience spanning more than eight years in litigation before various court levels and providing specialized legal consultations to individuals and companies.',
    commitment: 'The office is keen to provide its legal services to citizens and residents of various nationalities inside and outside Kuwait, with the aim of achieving the best legal results for its clients, through in-depth study of each case, developing well-thought-out legal strategies, and continuous follow-up until reaching optimal legal solutions.',
    services: 'The office also provides its services in both Arabic and English, meeting the needs of local and international clients, keeping pace with developments in the legal environment, with full commitment to information confidentiality and protection of clients\' interests.',
    partner: 'Lawyer Ghadeer Salem Ashkanani Office is not limited to litigation or providing consultations only, but seeks to be a trusted legal partner for its clients, by providing comprehensive legal support that enhances legal positions and protects rights with confidence and professionalism.',
  },
  services: {
    title: 'Our Legal Services',
    subtitle: 'Comprehensive Legal Solutions',
    description: 'Lawyer Ghadeer Salem Ashkanani Office for Law and Legal Consultations provides comprehensive legal services covering various branches of law, with commitment to accuracy, professionalism, and good case management to achieve the best results for our clients.',
    criminal: {
      title: 'Criminal Cases',
      description: 'Defense in all types of criminal cases including felonies and misdemeanors',
    },
    civil: {
      title: 'Civil and Commercial Cases',
      description: 'Comprehensive legal representation in all forms of civil and commercial cases',
    },
    labor: {
      title: 'Labor Cases',
      description: 'Resolving labor disputes and protecting the rights of workers and employers',
    },
    administrative: {
      title: 'Administrative Judiciary',
      description: 'Appealing administrative decisions before competent courts',
    },
    family: {
      title: 'Family Cases',
      description: 'Personal status cases according to Jaafari and Sunni jurisprudence',
    },
    arbitration: {
      title: 'Commercial Arbitration',
      description: 'Alternative dispute resolution and international commercial arbitration',
    },
  },
  team: {
    title: 'Our Team',
    subtitle: 'Team of Legal Experts',
    founder: {
      name: 'Dr. Ghadeer Ashkanani',
      role: 'Founder & CEO',
      description: 'Specialized lawyer in commercial and corporate law with over 8 years of experience providing legal consultations to large and medium-sized companies. Holds a Masters degree in International Commercial Law.',
    },
    consultant1: {
      name: 'Lawyer Ahmed Al-Khaldi',
      role: 'Senior Legal Consultant',
      description: 'Specialized in labor law and social insurance with 10 years of experience representing companies and employees in labor disputes.',
    },
    consultant2: {
      name: 'Lawyer Faisal Al-Otaibi',
      role: 'Legal Consultant',
      description: 'Expert in commercial arbitration and dispute resolution with a proven track record in resolving complex commercial cases locally and internationally.',
    },
    coordinator1: {
      name: 'Lawyer Khaled Al-Mutairi',
      role: 'Court Procedures Coordinator',
      description: 'Specialized in following up on judicial procedures and managing cases before Kuwaiti courts with high efficiency.',
    },
    coordinator2: {
      name: 'Lawyer Saad Al-Rashidi',
      role: 'Legal Coordinator',
      description: 'Expert in preparing legal briefs and contracts with meticulous attention to legal and procedural details.',
    },
    lawyer1: {
      name: 'Lawyer Noura Al-Salem',
      role: 'Personal Status Lawyer',
      description: 'Specialized in personal status and family cases with 6 years of experience handling sensitive cases with confidentiality and professionalism.',
    },
    lawyer2: {
      name: 'Lawyer Abdullah Al-Dosari',
      role: 'Real Estate Lawyer',
      description: 'Expert in real estate law and real estate development with extensive experience in drafting sale, lease and development contracts.',
    },
    lawyer3: {
      name: 'Lawyer Maryam Al-Hajri',
      role: 'Intellectual Property Lawyer',
      description: 'Specialized in intellectual property protection and trademarks with experience in registering and protecting intellectual property rights.',
    },
    paralegal1: {
      name: 'Fatima Al-Anzi',
      role: 'Legal Assistant',
      description: 'Specialized in legal research and document preparation with 4 years of experience supporting the legal team.',
    },
    paralegal2: {
      name: 'Mohammed Al-Balushi',
      role: 'Legal Assistant',
      description: 'Expert in managing legal files and coordinating with government agencies to complete transactions quickly and efficiently.',
    },
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'We are here to help you',
    name: 'Name',
    email: 'Email',
    phone: 'Phone Number',
    message: 'Your Message',
    send: 'Send',
    info: 'Contact Information',
    address: 'Kuwait',
  },
  booking: {
    title: 'Book Legal Consultation',
    subtitle: 'Book Your Appointment Now',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone Number',
    caseType: 'Case Type',
    date: 'Appointment Date',
    time: 'Appointment Time',
    details: 'Case Details',
    submit: 'Confirm Booking',
    selectType: 'Select Case Type',
    selectTime: 'Select Time',
  },
  footer: {
    description: 'A leading law firm in Kuwait providing comprehensive legal solutions since 2018',
    quickLinks: 'Quick Links',
    services: 'Services',
    legal: 'Legal',
    privacy: 'Privacy Policy',
    terms: 'Terms and Conditions',
    rights: 'All Rights Reserved',
    newsletter: 'Subscribe to Our Newsletter',
    subscribe: 'Subscribe',
    emailPlaceholder: 'Your Email',
  },
};